import { render } from "./LbrxCreateCustomer.vue?vue&type=template&id=6a1ee98c&scoped=true"
import script from "./LbrxCreateCustomer.vue?vue&type=script&lang=js"
export * from "./LbrxCreateCustomer.vue?vue&type=script&lang=js"

import "./LbrxCreateCustomer.vue?vue&type=style&index=0&id=6a1ee98c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1ee98c"]])

export default __exports__